class BundleSuite extends HTMLElement {
	constructor() {
		super();
		
		this.productId = this.dataset.productId;
	}

	connectedCallback() {
		console.log('BundleSuite connected');
		
		this.init();
	}

	clickAccordionHeaders() {
		const headers = document.querySelectorAll('.accordion-header');

		headers.forEach((header) => {
			if (!header.dataset.clicked) {
				header.click();
				header.dataset.clicked = 'true';
			}
		});
	}

	init() {
		const observer = new MutationObserver(() => {
			this.clickAccordionHeaders();
		});

		observer.observe(document.body, { childList: true, subtree: true });

		this.clickAccordionHeaders();
	}
}

if (!window.customElements.get('bundle-suite')) {
	window.customElements.define('bundle-suite', BundleSuite);
}
